import React, { useEffect } from "react"

import WrongRed from "../../images/icons/wdn-wrong-red.svg"
import EditBlue from "../../images/icons/wdn-edit-blue.svg"

const SocialTag = ({ name, deleteClick, editClick, link }) => {
  const handleDeleteClick = e => {
    e.preventDefault()
    deleteClick(true, name, "SOCIAL")
  }

  const handleEditClick = e => {
    e.preventDefault()
    editClick(true, name, link)
  }
  useEffect(() => {}, [link])
  return (
    <li className="d-inline-block">
      <div className="d-flex align-items-center social-tag p-2">
        <span className="text-capitalize">{name}</span>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          onClick={handleEditClick}
          className="btn background-transparent p-0 ml-2 "
        >
          <img src={EditBlue} alt="" />
        </a>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          onClick={handleDeleteClick}
          className="btn background-transparent p-0 ml-2 "
        >
          <img src={WrongRed} alt="" />
        </a>
      </div>
    </li>
  )
}

export default SocialTag
